<template>
  <main>
    <v-container v-if="loadingData">
      <h2>Loading ...</h2>
    </v-container>

    <template v-else>
      <v-container>
        <v-toolbar flat class="main-header mb-5 px-0">
          <v-toolbar-title class="main-header__title">
            <h1>
              Edit Reservation Order no. {{ form.wellspring_order_id }} -
              {{ form.camp_sub_type }}
            </h1>
          </v-toolbar-title>
        </v-toolbar>
        <h4 class="mb-5">{{ form.camp }}</h4>
        <v-alert v-if="globalServerErrors !== null" dense outlined type="error">
          <p
            class="mb-0"
            v-for="globalErr in globalServerErrors"
            :key="globalErr"
          >
            {{ globalErr[0] }}
          </p>
        </v-alert>
        <form @submit.prevent="handleSave" class="form-box">
          <template>
            <v-row>
              <v-col sm="2" class="pb-0"><span>Transportation</span> </v-col>
              <v-col sm="2" class="pb-0"
                ><strong>{{ form.bus_price }}</strong></v-col
              >
              <v-col sm="2" class="py-0">
                <section class="transparent-field h-40">
                  <v-switch
                    class="mt-0"
                    :true-value="1"
                    :false-value="0"
                    v-model="form.has_bus"
                    :disabled="!form.camp_has_bus"
                  ></v-switch>
                </section>
              </v-col>
              <v-col v-if="busStops.length > 0" cols="12" class="pb-0">
                <v-select
                  class="w-300"
                  :items="busStops"
                  item-text="stop_point"
                  item-value="id"
                  regular
                  return-object
                  label="Select Bus Stop"
                  clearable
                  v-model="form.bus_stop_id"
                  :disabled="!form.camp_has_bus"
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col sm="2" class="pb-0"><span>Photos</span> </v-col>
              <v-col sm="2" class="pb-0"
                ><strong>{{ form.photo_price }}</strong></v-col
              >
              <v-col sm="2" class="py-0">
                <section class="transparent-field h-40">
                  <v-switch
                    v-model="form.has_photo"
                    class="mt-0"
                    color="primary"
                    :true-value="1"
                    :false-value="0"
                    :disabled="!form.camp_has_photo"
                  ></v-switch>
                </section>
              </v-col>
            </v-row>
            <v-row>
              <v-col sm="2" class="pb-0"><span>Meals</span> </v-col>
              <v-col sm="2" class="pb-0"
                ><strong>{{ form.meal_price }}</strong></v-col
              >
              <v-col sm="2" class="py-0">
                <section class="transparent-field h-40">
                  <v-switch
                    v-model="form.has_meal"
                    class="mt-0"
                    color="primary"
                    :true-value="1"
                    :false-value="0"
                    :disabled="!form.camp_has_meal"
                  ></v-switch>
                </section>
              </v-col>
            </v-row>
            <v-row>
              <v-col sm="2" class="pb-0"><span>Early Checkin</span> </v-col>
              <v-col sm="2" class="pb-0"
                ><strong>{{ form.early_check_in_price }}</strong></v-col
              >
              <v-col sm="2" class="py-0">
                <section class="transparent-field h-40">
                  <v-switch
                    v-model="form.has_early_check_in"
                    class="mt-0"
                    color="primary"
                    :true-value="1"
                    :false-value="0"
                    :disabled="!form.camp_has_early_check_in"
                  ></v-switch>
                </section>
              </v-col>
            </v-row>
            <v-row>
              <v-col sm="2" class="pb-0"><span>Late Checkout</span> </v-col>
              <v-col sm="2" class="pb-0"
                ><strong>{{ form.late_check_out_price }}</strong></v-col
              >
              <v-col sm="2" class="py-0">
                <section class="transparent-field h-40">
                  <v-switch
                    v-model="form.has_late_check_out"
                    class="mt-0"
                    color="primary"
                    :true-value="1"
                    :false-value="0"
                    :disabled="!form.camp_has_late_check_out"
                  ></v-switch>
                </section>
              </v-col>
            </v-row>
            <v-row>
              <v-col sm="2" class="pb-0"><span>Special Needs</span> </v-col>
              <v-col sm="2" class="pb-0"
                ><strong>{{ form.special_needs_price }}</strong></v-col
              >
              <v-col sm="2" class="py-0">
                <section class="transparent-field h-40">
                  <v-switch
                    v-model="form.has_special_needs"
                    class="mt-0"
                    color="primary"
                    :true-value="1"
                    :false-value="0"
                    :disabled="!form.camp_has_special_needs"
                  ></v-switch>
                </section>
              </v-col>
              <v-col cols="12" class="text-right">
                <v-btn
                  color="primary"
                  large
                  v-if="form.available_campers.length > 0"
                  @click="camperAdd = true"
                >
                  <v-icon small class="pr-2">mdi-plus</v-icon>
                  Add Camper</v-btn
                >
              </v-col>
            </v-row>
            <section v-for="(camper, index) in form.campers" :key="index">
              <v-toolbar flat class="main-header px-0">
                <v-toolbar-title class="main-header__title">
                  <h2>
                    <span class="gray">Camper Name : </span>{{ camper.name }}
                  </h2>
                </v-toolbar-title>

                <v-spacer></v-spacer>
                <v-toolbar-items class="align-items-center">
                  <h2 class="pt-4">{{ camper.child_price }}</h2>
                  <v-btn
                    v-if="form.campers.length > 1"
                    title="Remove Camper"
                    @click="deleteChild(index)"
                    color="error"
                    icon
                    ><v-icon>mdi-delete</v-icon></v-btn
                  >
                </v-toolbar-items>
              </v-toolbar>
              <hr class="mt-3 mb-5" />
              <v-row>
                <v-col
                  class="py-0"
                  cols="12"
                  v-for="camperKey in camperKeys"
                  :key="camperKey.index"
                >
                  <!-- {{ camperKey.label }} -->
                  <v-row>
                    <v-col cols="12" sm="5" class="py-0">
                      <v-select
                        :items="camperKey.items"
                        item-text="name"
                        item-value="id"
                        regular
                        return-object
                        :label="camperKey.label"
                        clearable
                        v-model="camper[camperKey.name]"
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </section>
          </template>
          <template v-if="parents.length > 0">
            <section v-for="parent in parents" :key="parent.index">
              <h2><span class="gray">Parent Name : </span>{{ parent.name }}</h2>
              <hr class="mt-3 mb-5" />
              <v-row>
                <v-col class="py-0" cols="12" sm="5">
                  <v-select
                    :items="clothes"
                    item-text="name"
                    item-value="id"
                    return-object
                    regular
                    label="T-shirt Size"
                    clearable
                    v-model="parent.clothes_size_id"
                  ></v-select>
                </v-col>
              </v-row>
            </section>
          </template>
          <v-row>
            <v-col cols="12">
              <h2>Details</h2>
              <hr class="mt-3 mb-5" />
              <v-row>
                <v-col sm="5">
                  <v-row>
                    <v-col class="py-0" cols="12" sm="12">
                      <v-select
                        :items="teams"
                        item-text="name"
                        item-value="id"
                        regular
                        return-object
                        label="Team"
                        clearable
                        @change="teamParticipants"
                        v-model="form.team_id"
                      ></v-select>
                    </v-col>
                    <v-col class="py-0" cols="12">
                      <v-select
                        :items="majors"
                        item-text="full_name"
                        item-value="id"
                        regular
                        return-object
                        label="Major"
                        clearable
                        v-model="form.major_id"
                        :disabled="majors.length == 0"
                      ></v-select>
                    </v-col>
                    <v-col class="py-0" cols="12">
                      <v-select
                        :items="discounts"
                        item-text="name"
                        item-value="id"
                        regular
                        return-object
                        label="Select Discount"
                        clearable
                        v-model="form.discount_id"
                        :disabled="discounts.length == 0"
                      ></v-select>
                      <p>
                        Current Discount :
                        <span v-if="form.discount_id">{{
                          form.discount_id.name
                        }}</span>
                        <span v-else>None</span>
                      </p>
                    </v-col>
                    <template v-if="!parents.length > 0">
                      <v-col cols="12" class="py-0">
                        <h4>Pickers</h4>
                        <hr class="my-2" />
                      </v-col>
                      <v-col class="py-0" sm="6" cols="12">
                        <v-text-field
                          regular
                          label="Picker 1"
                          v-model.trim="form.contact_1_name"
                          type="text"
                        >
                        </v-text-field>
                      </v-col>
                      <v-col class="py-0" sm="6" cols="12">
                        <v-text-field
                          regular
                          label="Mobile"
                          v-model.trim="form.contact_1_phone"
                          type="text"
                        >
                        </v-text-field>
                      </v-col>
                      <v-col class="py-0" sm="6" cols="12">
                        <v-text-field
                          regular
                          label="Picker 2"
                          v-model.trim="form.contact_2_name"
                          type="text"
                        >
                        </v-text-field>
                      </v-col>
                      <v-col class="py-0" sm="6" cols="12">
                        <v-text-field
                          regular
                          label="Mobile"
                          v-model.trim="form.contact_2_phone"
                          type="text"
                        >
                        </v-text-field>
                      </v-col>
                      <v-col class="py-0" sm="6" cols="12">
                        <v-text-field
                          regular
                          label="Emergency"
                          v-model.trim="form.emergency_contact_name"
                          type="text"
                        >
                        </v-text-field>
                      </v-col>
                      <v-col class="py-0" sm="6" cols="12">
                        <v-text-field
                          regular
                          label="Mobile"
                          v-model.trim="form.emergency_contact_phone"
                          type="text"
                        >
                        </v-text-field>
                      </v-col>
                    </template>
                  </v-row>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    label="Notes"
                    regular
                    v-model.trim="form.notes"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12">
              <hr class="mt-3" />
              <v-toolbar flat class="main-header px-0 pt-0">
                <v-toolbar-title class="main-header__title">
                  <h2>Total Price</h2>
                </v-toolbar-title>

                <v-spacer></v-spacer>
                <v-toolbar-items class="align-items-center">
                  <h2 class="pt-4">
                    {{ form.price_after_discount }}
                  </h2>
                </v-toolbar-items>
              </v-toolbar>
            </v-col>
            <v-col cols="12" lg="2" sm="6" class="text-center">
              <v-btn
                class="text-capitalize"
                large
                color="primary"
                type="submit"
                width="100%"
                ><span>Submit</span></v-btn
              >
            </v-col>
            <v-col lg="2">
              <v-btn text large to="/bookings">Cancel</v-btn>
            </v-col>
            <v-col lg="8" class="text-right">
              <template>
                <v-btn
                  class="mx-2"
                  large
                  :disabled="prev == null"
                  :to="{ name: 'reservationsEdit', params: { id: prev } }"
                  @click="handleSave"
                  >Previous</v-btn
                >
                <v-btn
                  :disabled="next == null"
                  large
                  color="success"
                  :to="{ name: 'reservationsEdit', params: { id: next } }"
                  @click="handleSave"
                  >Next</v-btn
                >
              </template>
            </v-col>
          </v-row>
        </form>
      </v-container>
      <v-dialog v-model="dialog" width="500">
        <v-card class="pt-5">
          <v-alert
            v-if="form.team_id.remaining_spots <= 0"
            dense
            outlined
            class="pt-3 mx-5"
            type="error"
          >
            Are you sure you want to select this team? <br />
            <strong>It will lead to Overbooking</strong>
          </v-alert>
          <v-card-title
            v-if="participants.length > 0"
            class="lighten-2 pt-0"
            primary-title
          >
            <strong>Participants</strong>
          </v-card-title>
          <v-card-text class="pb-0">
            <ul v-if="participants.length > 0">
              <li v-for="participant in participants" :key="participant.index">
                {{ participant.parent || participant.full_name }}
              </li>
            </ul>

            <p v-else class="text-center mt-3 mb-0">
              <strong>No Participants Added Yet</strong>
            </p>
          </v-card-text>

          <!-- <v-divider></v-divider> -->

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="dialog = false"> Ok </v-btn>
            <v-btn color="primary" text @click="cancel"> Cancel </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="camperAdd" width="500">
        <v-card>
          <v-card-title class="lighten-2" primary-title>
            <strong>Adding Campers</strong>
          </v-card-title>
          <v-card-text>
            <v-select
              :items="form.available_campers"
              item-text="name"
              item-value="id"
              label="Select"
              multiple
              return-object
              chips
              v-model="selectedCampers"
            ></v-select>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="add"> Save </v-btn>
            <v-btn color="primary" text @click="camperAdd = false">
              Cancel
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <printed-receipt :item="item" id="section-to-print"></printed-receipt>
    </template>
  </main>
</template>

<script>
import { ShowData, IndexData, StoreData } from "@/helpers/apiMethods";

export default {
  data() {
    return {
      form: {
        id: this.$route.params.id,
        camper: {
          grade_id: {
            id: null,
            name: null,
          },
        },
        parent: {
          clothes_size_id: {
            id: null,
            name: null,
          },
        },
        team_id: {
          id: null,
          name: null,
        },
        major_id: {
          id: "",
          name: "",
        },
        discount_id: {
          id: "",
          name: "",
        },
        bus_stop_id: {
          id: "",
          name: "",
        },
        notes: "",
        has_photo: null,
        has_meal: null,
        has_early_check_in: null,
        has_late_check_out: null,
        has_special_needs: null,
        dummyTeam: {},
      },
      parents: [],
      busDisabled: true,
      wellspring_order_id: null,
      grades: [],
      teams: [],
      majors: [],
      discounts: [],
      busStops: [],
      clothes: [],
      yesno: "",
      globalServerErrors: null,
      dialog: false,
      participants: [],
      next: null,
      prev: null,
      item: {},
      loadingData: false,
      camperAdd: false,
      selectedCampers: [],
    };
  },
  components: {
    PrintedReceipt: () =>
      import("@/views/bookings/reciepts/components/PrintedReceipt.vue"),
  },
  created() {
    this.indexGrades();
    this.indexClothes();
  },
  computed: {
    camperKeys() {
      return [
        { name: "grade_id", items: this.grades, label: "Grade" },
        { name: "clothes_size_id", items: this.clothes, label: "T-shirt Size" },
      ];
    },
    majorVal() {
      if (this.major_id != null) {
        return this.major_id.id;
      } else {
        return "";
      }
    },
  },
  methods: {
    indexGrades() {
      IndexData({ reqName: `/grades` })
        .then((res) => {
          const { data } = res.data;
          this.grades = data;
        })
        .catch(() => {})
        .finally(() => {});
    },
    indexClothes() {
      IndexData({ reqName: `/clothes-sizes` })
        .then((res) => {
          const { data } = res.data;
          this.clothes = data;
        })
        .catch(() => {})
        .finally(() => {});
    },
    showReservations(id) {
      this.loadingData = true;
      ShowData({
        reqName: `reservations`,
        id,
      })
        .then((res) => {
          this.form = res.data.reservation;
          this.dummyTeam = res.data.reservation.team_id;
          this.teams = res.data.teams;
          this.majors = res.data.majors;
          this.discounts = res.data.discounts;
          this.busStops = res.data.bus_stops;
          this.next = res.data.next;
          this.prev = res.data.prev;
          this.parents = res.data.reservation.parents;
          this.loadingData = false;

          if (res.data.reservation.has_bus == 0) {
            this.yesno = "No";
          } else {
            this.yesno = "Yes";
          }
          if (res.data.reservation.major_id == null) {
            this.form.major_id.id = "";
          }
          if (res.data.reservation.discount_id == null) {
            this.form.discount_id = {};
          }
          if (res.data.reservation.bus_stop_id == null) {
            this.form.bus_stop_id.id = "";
          }
        })
        .catch(() => {});
    },
    handleSave() {
      const formData = new FormData();
      Object.keys(this.form).forEach((formItem) => {
        if (this.form[formItem] && formItem === "team_id") {
          formData.append(formItem, this.form[formItem].id || "");
        } else if (this.form[formItem] && formItem === "discount_id") {
          formData.append(formItem, this.form[formItem].id || "");
        } else if (this.form[formItem] && formItem === "major_id") {
          formData.append(formItem, this.form[formItem].id || "");
        } else if (this.form[formItem] && formItem === "bus_stop_id") {
          formData.append(formItem, this.form[formItem].id || "");
        } else if (this.form[formItem] == null || formItem === "campers") {
          return;
        } else {
          formData.append(formItem, this.form[formItem]);
        }
      });

      if (this.form.campers.length > 0) {
        this.form.campers.forEach((camper, index) => {
          Object.keys(camper).forEach((camperItem) => {
            if (camperItem === "grade_id" || camperItem === "clothes_size_id") {
              formData.append(
                `campers[${index}][${camperItem}]`,
                camper[camperItem].id
              );
            } else if (
              camperItem === "name" ||
              camperItem === "full_name" ||
              camperItem === "age"
            ) {
              return;
            } else {
              formData.append(
                `campers[${index}][${camperItem}]`,
                camper[camperItem]
              );
            }
          });
        });
      }
      if (this.form.parents.length > 0) {
        this.form.parents.forEach((parent, index) => {
          Object.keys(parent).forEach((parentItem) => {
            if (parentItem === "clothes_size_id") {
              formData.append(
                `parents[${index}][${parentItem}]`,
                parent[parentItem].id
              );
            } else if (parentItem === "name" || parentItem === "grade_id") {
              return;
            } else {
              formData.append(
                `parents[${index}][${parentItem}]`,
                parent[parentItem]
              );
            }
          });
        });
      }
      StoreData({
        reqName: `reservations`,
        data: formData,
      })
        .then((res) => {
          const { receipt } = res.data;
          if (receipt) {
            this.item = receipt;
            this.$nextTick(() => {
              window.print(receipt);
            });
          }
          this.scrollTop();
          this.showReservations(this.$route.params.id);
        })
        .catch((err) => {
          this.globalServerErrors = err.response.data.errors;
          this.scrollTop();
        })
        .finally(() => {
          if (this.next == null && this.prev == null) {
            history.go(-1);
          }
        });
    },
    teamParticipants(item) {
      this.participants = item.participants;
      this.dialog = true;
    },
    scrollTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    cancel() {
      this.dialog = false;
      this.form.team_id = this.dummyTeam;
    },
    add() {
      this.selectedCampers.map((el) => {
        this.form.campers.push(el);
        this.camperAdd = false;
      });
    },
    deleteChild(index) {
      this.popUp().then((value) => {
        if (!value.dismiss) {
          this.form.campers.splice(index, 1);
        }
      });
    },
  },
  watch: {
    $route: {
      handler(route) {
        this.showReservations(route.params.id);
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
